import update from 'immutability-helper'
import {BLANK, MUL_VALS} from './utils'
// import {expandOptions} from './translation'


const hasOpt = function(item, options, verbose){
  // console.log(item, options)
  if( verbose ) console.log(`seeing if ${item} exists in`, options)
  if( !options ) return null
  try{
    let opt = options.filter(option => option && option._name === item)
    if( verbose ) console.log('filtered out', opt)
    if( opt.length ) return opt[0]
  }catch(e){
    console.log('options failed', item, options)
  }
  return null
}

const wrp = function(control, source, leaf, cb){
  if( !source ) return source
  else {
    let {options} = control
    // options = expandOptions(options)
    let res = cb(control, source, leaf, options)
    if( res ) return res
    return source
  }
}

const wrpLeaf = function(control, source, leaf, cb){
  if( !leaf ) return leaf
  else {
    let {options} = control
    // options = expandOptions(options)
    let res = cb(control, source, leaf, options)
    if( res ) return res
    return leaf
  }
}

// Options that affect a control's source (like the different values in dropdowns)
const sourceOptions = [
  function multipleValues(control, source, leaf){
    let content = leaf.content && leaf.content.length && leaf.content[0]
    // console.log('check mulvals for', control.name, leaf.content)
    if( !content ) return

    if( content._mult || content._name === MUL_VALS._name ) {
      source = [MUL_VALS, ...source]
    }
    return source
  },
  function blankInitial(control, source, leaf, options){
    if( hasOpt('blank-initial', options) ){
      if( !source.includes(BLANK) ){
        source = [BLANK, ...source]
      }
    }
    return source
  },
  function freeEntry(control, source, leaf, options){
    // activate EITHER when we have 'free-entry' option on arbitrary control
    // OR when we are a text and we DON'T have 'no-free-entry'
    // console.log('check', control.type)
    if(
      hasOpt('free-entry', options) ||
      (!hasOpt('no-free-entry', options) && control.type === 'text')
     ){
       // console.log('adding free entry source to', control.name)
       if( leaf.content && leaf.content[0] ){
         if( typeof leaf.content[0]._name === 'string' ) {
           // console.log('adding source option', leaf.content._name)
           const enteredOption = {
             ...leaf.content[0],
             _name: leaf.content[0]._name,
             _mask: leaf.content[0]._mask,
             _temp: true
           }
           source = source.filter(elm => !elm._temp)
           source = [enteredOption, ...source]
         }
       }
    }
    return source
  }
]

const setInitial = function(control, source, leaf, options){
  let opt = hasOpt('set-initial', options)
  // console.log('check options of', control.name, options, opt)
  // console.log(opt, opt && opt.arg1)
  // if( control.name === 'curFavesList' ){
  //   console.log('considering options for curFavesList', options, opt)
  // }
  if( opt ) {
    // console.log('set-initial option exists on', control.name)
    let idx = parseInt(opt.arg1, 10)
    if( typeof idx === 'number' ) {
      // console.log('running first-initial on', control.name, leaf, source)
      const {content} = leaf
      if( !content || !content.length ) {
        if( source && source.length ){
          const target = source[idx]
          if( target ) return update(leaf, {
            'content': {'$set': [target]}
          })
          return []
        }
      }
    }
  }

}

const freeEntry = function(control, source, leaf, options){
  // console.log('process control', leaf, source)
  if(
    hasOpt('free-entry', options) ||
    (!hasOpt('no-free-entry', options) && control.type === 'text')
  ) {
    let temp = []
    if( source ){
      temp = source.filter(elm => elm._temp)
    }
    if( !temp.length ) {
      let {content} = leaf
      if( content && content.length ){
        temp = [{
          ...content[0],
          _name: content[0]._name,
          _mask: content[0]._mask,
          _temp: true
        }]
        // console.log('no temp so set with content', control.name, content, temp)
      }
      // if(content.length>1) temp = [...temp, ...content]
    }
    // console.log('leaf option setting temp', control.name, temp, leaf.content)
    return update(leaf, {
      'content': {'$set': temp}
    })
  } else {
    // Standard behaviour -- find the item in the source, if it exists, set it
    // Otherwise, clear the item
    let final = []
    let {content} = leaf
    content = content || []
    // console.log(content)
    if( source && source.length ){
      // console.log(content, source)
      for( let elm of content ){
        let contentIdx = source.findIndex(e => e._name === elm._name)
        // console.log(elm, source, contentIdx)
        if( ~contentIdx ){
          // console.log('looking for', val)
          // console.log('found at', contentIdx)
          // console.log(sources, source[contentIdx])
          // console.log('content', content)
          final.push(source[contentIdx])
        }
      }
      // console.log('found all values, return', final)
      return update(leaf, {
        'content': {'$set': final}
      })
    }
    return leaf
  }
}

const dropControlTypes = ['dropdown', 'multiselect', 'radio']
const nonInitializedDropdowns = function(control, source, leaf, options){
  // Dropdowns that are not initialized to a specific point in their index, or
  // ones that aren't told to have a blank initial value, should initialize to
  // the first element in their source (as these dropdowns, by default, select
  // their first value; all child dropdowns need to be notified of this).
  // Without this option, hierarchies of dropdowns do not initialize properly.
  if( dropControlTypes.includes(control.type) && !hasOpt('no-initial', options) ){
    // console.log('check dropdown', control.name)
    let setInitialOpt = hasOpt('set-initial', options)
    let blankInitialOpt = hasOpt('blank-initial', options)
    // console.log('dropdown opts', options)
    if( !setInitialOpt && !blankInitialOpt ){
      let o = options || []
      // console.log('initializing dropdown', control.name)
      return setInitial(control, source, leaf, [...o, {_name: 'set-initial', arg1: 0}])
    }
  }
}

const leafOptions = [
  freeEntry,
  setInitial,
  nonInitializedDropdowns
]

const processLeafOptions = function(control, source, leaf){
  for( let leafOptionFn of leafOptions ){
    leaf = wrpLeaf(control, source, leaf, leafOptionFn)
    // console.log('received leaf', leaf)
  }
  return leaf
}

const processSourceOptions = function(control, source, leaf){
  for( let sourceOptionFn of sourceOptions ){
    source = wrp(control, source, leaf, sourceOptionFn)
  }
  return source
}

export {
  processSourceOptions,
  processLeafOptions,
  hasOpt
}
